import { render } from "./DiamondStock.vue?vue&type=template&id=7efa8ad2&scoped=true"
import script from "./DiamondStock.vue?vue&type=script&lang=js"
export * from "./DiamondStock.vue?vue&type=script&lang=js"

import "./DiamondStock.vue?vue&type=style&index=0&id=7efa8ad2&lang=scss"
import "./DiamondStock.vue?vue&type=style&index=1&id=7efa8ad2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efa8ad2"]])

export default __exports__